/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter, yearToCropYearShort, useDictionaryItem } from "../../shared";
import { CalendarControl } from "./controls/CalendarControl";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { BusinessUnitControl } from "./controls/BusinessUnitControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { dictionaryService } from "../../dataFlow";
import { SLIDE_NUMBER } from "./constants";

export default function (props: { exportMode?: boolean }) {
  const { exportMode } = props;
  const [business, setBusiness] = useParameter<number>("@business-units");
  const bname = (business || 1) === 2 ? "APE" : "World";
  const bcrops = (business || 1) === 2 ? "" : "AP";

  const description =
    Number(business) === 2
      ? [
          "Showing the crop areas worldwide (Change in %) from one marketing year to the other and 1 forecast year",
          "Source: USDA PS&D (Field crops), FAO (Fruits & Vegetables), Global Insight and Eurostat for individual EU countries",
        ]
      : [
          "Showing the crop areas worldwide (Change in %) from one marketing year to the other and 1 forecast year",
          "Source: USDA PS&D (Field crops) and FAPRI (Sugar Crops)",
        ];
  const title = `${bname} overview - ${bcrops} major crops: annual area development (in %)`;

  useExportQuery(title, "");
  useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={""} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup>
          <BusinessUnitControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
